const indexItems = [
  { icon: 'ri-fire-line', label: '动作大片', count: '3280部', color: 'text-accent-400' },
  { icon: 'ri-heart-line', label: '爱情文艺', count: '2156部', color: 'text-primary-400' },
  { icon: 'ri-ghost-line', label: '悬疑惊悚', count: '1892部', color: 'text-secondary-400' },
  { icon: 'ri-rocket-line', label: '科幻奇幻', count: '1567部', color: 'text-accent-400' },
  { icon: 'ri-emotion-laugh-line', label: '喜剧搞笑', count: '2430部', color: 'text-primary-400' },
  { icon: 'ri-live-line', label: '国产剧集', count: '4120部', color: 'text-secondary-400' },
  { icon: 'ri-global-line', label: '海外剧集', count: '3650部', color: 'text-accent-400' },
];

export default function AboutIndexSection() {
  return (
    <>
      <section id="about" className="relative w-full py-16 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
              关于6080新视觉影院
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
              6080新视觉影院创立于2018年，是国内领先的高清电影电视剧免费在线观看平台。我们致力于打造不缓冲、极速秒开的观影体验，让每一位用户都能享受全集不卡顿流畅播放的高品质服务。
            </p>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
              平台汇聚了超过两万部高清影视资源，涵盖动作、喜剧、悬疑、科幻、爱情、动画等多种类型。每日持续更新，确保用户能够在第一时间观看到最新上映的热门电影和电视剧。
            </p>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
              我们采用先进的分布式CDN加速和智能码率自适应技术，无论您使用何种设备或网络环境，6080新视觉影院都能为您提供高清不卡的免费影视大全服务。
            </p>
          </div>
        </div>
      </section>

      <section id="index" className="relative w-full py-16 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              影视索引
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              七大分类索引，快速找到你想看的电影电视剧
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
            {indexItems.map((item, idx) => (
              <div
                key={idx}
                className="group bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/40 hover:border-primary-500/20 transition-all duration-300 cursor-pointer text-center"
              >
                <div className={`w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-background-200/60 mb-3 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${item.icon} text-lg ${item.color}`}></i>
                </div>
                <h3 className="text-sm font-semibold font-heading text-foreground-800 mb-1 whitespace-nowrap">
                  {item.label}
                </h3>
                <p className="text-xs text-foreground-500">{item.count}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}